import React, {useContext} from 'react'

import antdEnGb from 'antd/locale/en_GB'
import antdRu from 'antd/locale/ru_RU'

import 'dayjs/locale/en-gb'
import 'dayjs/locale/ru'

export const Locales = {
  en: {
    antd: antdEnGb,
    dayjs: 'en-gb',
  },
  ru: {
    antd: antdRu,
    dayjs: 'ru',
  },
}

export type SupportedLocale = 'en' | 'ru'

export const LocalizationContext = React.createContext<{
  setLocale: (locale: SupportedLocale) => void
  getLocale: () => SupportedLocale
}>({
  setLocale: () => {},
  getLocale: () => 'en',
})

export function useChangeLocale() {
  const localizationContext = useContext(LocalizationContext)

  return (newLocale: SupportedLocale) => {
    localStorage.setItem('locale', newLocale)
    localizationContext.setLocale(newLocale)
  }
}

export function useLocale() {
  const localizationContext = useContext(LocalizationContext)

  return localizationContext.getLocale()
}
